(function($) {
    $(document).ready(function() {

        // handle menu
        function handleNav(itemClicked) {
            console.log('**********handleNav');
            
            var activeDropdown = $('#main-menu > .dropdown-menu');
            var currentPageNotInActiveDropdown = activeDropdown.find('.nav-item.current_page_item').length === 0;
    
            activeDropdown.find('.nav-item a').each(function() {
                $(this).removeClass('active-item');
            });
        
            if(currentPageNotInActiveDropdown){
                // show preview of first menu item
                activeDropdown.find('.nav-item:nth-of-type(1) a').addClass('active-item');
            } else {
                // show preview of current page item
                activeDropdown.find('.nav-item.current_page_item a').addClass('active-item');
            };
        
            // show preview of last hovered item
            activeDropdown.find('.nav-item a').hover(
                function() {
                    activeDropdown.find('.nav-item a').each(function() {
                        $(this).removeClass('active-item');
                    });
                    
                    $(this).addClass('active-item');
    
                    if(!currentPageNotInActiveDropdown){
                        // remove current page item indicator
                        $('.current_page_item > .dropdown-item').css('border-bottom-color', 'transparent');
                    }
                }
            );
        };
    
        function setupMenu() {
                
            // reset event listeners
            $('#main-menu > .menu-item > a').off('mouseenter mouseleave');
            $('#main-menu > .dropdown-menu').off('mouseleave');
            $('#page div:not(.stickyHeader)').off('click');
            $('#main-menu > .menu-item').off('click');
            $('#main-nav .navbar-toggler').off('click');
            $('#main-menu-mobile > .menu-item .dropdown-toggle').off('click');
    
        
            if (window.innerWidth >= 992) {
                $('#main-menu > .menu-item > a').hover(function() {
                    handleNav(this);
                    $('#main-menu > .menu-item a').removeClass('show');
                    $('#main-menu > .dropdown-menu').removeClass('show');
                    $(this).addClass('show');
                    $('#main-menu > .dropdown-menu').addClass('show');
                });
        
                $('#main-menu > .dropdown-menu').on('mouseleave', function(e) {
                    $('#main-menu > .menu-item a').removeClass('show');
                    $(this).removeClass('show');
                });
        
                $('#page div:not(.stickyHeader)').on('click', function(e) {
                    $('#main-menu > .menu-item a').removeClass('show');
                    $('#main-menu > .dropdown-menu').removeClass('show');
                });
            } else {
                // handle mobile menu toggle
                $('#main-nav .navbar-toggler').on('click', function () {
                    var $button = $(this);
                    var target = $button.data('target');
                    var $menu = $(target);
                    var $overlay = $('.overlay');
            
                    if ($button.hasClass('collapsed')) {
                        $menu.removeClass('hide').addClass('show');
                        $button.removeClass('collapsed').attr('aria-expanded', 'true');
                        $overlay.addClass('d-block');
                        $menu.trigger('show');
                        $menu.find('.navbar-nav').children().each(function() {
                            var element = $(this);
                            
                            if (element.hasClass('current_page_parent') && !element.find('.dropdown-toggle').hasClass('active-item')) {
                                element.find('.dropdown-toggle').addClass('active-item');
                                element.find('.sub-menu').addClass('show');
                            }
                        });
                    } else {
                        // Hide the menu
                        $menu.removeClass('show').addClass('hide');
                        $button.addClass('collapsed').attr('aria-expanded', 'false');
                        $menu.trigger('hide');
                        $overlay.removeClass('d-block');
                    }
                });

                $('#main-menu-mobile > .menu-item .dropdown-toggle').on('click', function(e) {
                    $('#main-menu-mobile > .menu-item .dropdown-toggle').not(this).removeClass('active-item');
                    $(this).toggleClass('active-item');
                    var $submenu = $(this).parent().siblings('.sub-menu');
                    $('#main-menu-mobile .sub-menu').not($submenu).removeClass('show');
                    $submenu.toggleClass('show');
                });
                
            }
        }
        
        setupMenu();
        $(window).resize(setupMenu);

        // play video in banner
        $('.play-video').on('click', function(){
            var video = $(this).closest('.video-banner').find('video')[0];
            
            if(video) {
                video.play();
            }
        });

        // handle searchandfilter category
        $('.searchandfilter_set_category').each(function() {
            var categoryElement = $(this);
            
            var categoryClass = categoryElement.attr('class').match(/category_([a-zA-Z0-9_-]+)/);
            if (categoryClass && categoryClass[1]) {
                var categoryValue = categoryClass[1];
                var formattedCategory = categoryValue.replace(/-/g, ' ').replace(/\b\w/g, function(l){ return l.toUpperCase(); });
                var selectElement = categoryElement.find('#ofcategory');
    
                if (selectElement.length) {
                    selectElement.find('option').each(function() {
                        var optionText = $(this).text().trim();
                        if (optionText === formattedCategory) {
                            $(this).prop('selected', true);
                            return false;
                        }
                    });
                }
            }
        });



        // handle tabs
        function initTabSet(tabSetElement) {
            tabSetElement.find('.nav-tabs .nav-link').each(function () {
                var tabId = $(this).attr('href');
                $(tabId).addClass('tab-pane');
                $(tabId).addClass('d-none');
            });

            var activeTabId = tabSetElement.find('.nav-tabs .nav-link.active').attr('href');
            $(activeTabId).removeClass('d-none');
        }

        // consider multiple tabs instances on one page
        $('.aveo-tabs').each(function () {
            initTabSet($(this));
        });

        // handle tabs nav
        $('.aveo-tabs .nav-tabs .nav-link').click(function (e) {
            e.preventDefault();
            var tabSet = $(this).closest('.aveo-tabs');
            tabSet.find('.nav-tabs .nav-link').removeClass('active');
            $(this).addClass('active');
            tabSet.find('.tab-pane').addClass('d-none');
            var tabId = $(this).attr('href');
            $(tabId).removeClass('d-none');
        });



        // open accordion on hash url
        function openAccordionFromHash() {
            if (window.location.hash) {
                const $targetAccordion = $(window.location.hash);

                if ($targetAccordion.length) {
                    const $accordionButton = $targetAccordion.find('.accordion-button');

                    if ($accordionButton.hasClass('collapsed')) {
                        $accordionButton.click();
                    }

                    // Additional scroll adjustment for better positioning
                    setTimeout(function () {
                        window.scrollTo({
                            top: $targetAccordion.offset().top - 150,
                            behavior: 'smooth'
                        });
                    }, 350);
                }
            }
        }

        openAccordionFromHash();
        $(window).on('hashchange', openAccordionFromHash);

        // open accordion on hash click
        $('a[href^="#"]').on('click', function (e) {
            const targetHash = $(this).attr('href');
            const $targetAccordion = $(targetHash);

            if ($targetAccordion.length) {
                e.preventDefault();
                window.location.hash = targetHash;
            }
        });

    }); // document ready
})(jQuery);
